import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'

interface TourModalActionsProps {
  onStart: () => void
  onSkip: () => void
}

export const TourModalActions: React.FC<TourModalActionsProps> = ({
  onStart,
  onSkip,
}) => {
  const { t } = useTranslation()

  return (
    <div className="space-y-4">
      <div className="flex gap-4">
        <Button
          className="bg-primary hover:bg-primary/90"
          onClick={onStart}
          data-testid="start-tour-button"
        >
          {t('tour-button-start')}
        </Button>
        <Button
          variant="outline"
          onClick={onSkip}
          data-testid="skip-tour-button"
        >
          {t('tour-button-skip')}
        </Button>
      </div>
      <p className="text-sm text-gray-500">{t('tour-skip-warning')}</p>
    </div>
  )
}
